<template>
    <div class="contractor-document-types-filters">
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Código"
                            v-model="code"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Nombre"
                            v-model="name"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <app-form-select-input
                            placeholder="Estado"
                            :options="statusOptions"
                            v-model="status"
                        />
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-btn variant="primary" @click="filter" class="btn-block">
                            <i class="fa fa-filter"></i> Filtrar
                        </b-btn>
                    </b-col>
                    <b-col cols="12" md="2">
                        <b-btn variant="secondary" @click="clearFilters" class="btn-block">
                            <i class="fa fa-times-circle"></i> Limpiar
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue';
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue';
import SubTitle from '../../UI/Layout/SubTitle.vue';

export default {
    components: {
        appFormSelectInput: FormSelectInput,
        appFormTextInput: FormTextInput,
        appSubTitle: SubTitle
    },
    props: {
        onFilter: {
            type: Function,
            required: true
        },
        onClearFilters: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            code: '',
            name: '',
            status: '',
            statusOptions: [
                { id: 'active', name: 'Activo' },
                { id: 'inactive', name: 'Inactivo' }
            ]
        };
    },
    methods: {
        filter() {
            const filters = {};
            if (this.code) filters.code = this.code;
            if (this.name) filters.name = this.name;
            if (this.status) filters.status = this.status;
            this.onFilter(filters);
        },
        clearFilters() {
            this.code = '';
            this.name = '';
            this.status = '';
            this.onClearFilters();
        }
    }
};
</script>
